export default {
  cloneObject(obj) {
    const objJSON = JSON.stringify(obj)
    return JSON.parse(objJSON)
  },

  log(message, value = null) {
    let timestamp = this.getCurrentTimestamp()

    if (value === null) {
      console.log(timestamp + ' TARIFF-CALC ' + message)
    } else {
      console.log(timestamp + ' TARIFF-CALC ' + message, value)
    }
  },

  getCurrentTimestamp() {
    const date = new Date()

    const year = date.getFullYear()
    const month = ('00' + (date.getMonth() + 1)).substr(-2)
    const day = ('00' + date.getDate()).substr(-2)
    const hours = ('00' + date.getHours()).substr(-2)
    const minutes = ('00' + date.getMinutes()).substr(-2)
    const seconds = ('00' + date.getSeconds()).substr(-2)

    return (
      year +
      '-' +
      ('00' + month).substr(-2) +
      '-' +
      ('00' + day).substr(-2) +
      ' ' +
      ('00' + hours).substr(-2) +
      ':' +
      ('00' + minutes).substr(-2) +
      ':' +
      ('00' + seconds).substr(-2)
    )
  },

  formatMoney(number, decPlaces, decSep = '.', thouSep = ',') {
    ;(decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
      (decSep = typeof decSep === 'undefined' ? '.' : decSep)
    thouSep = typeof thouSep === 'undefined' ? ',' : thouSep
    var sign = number < 0 ? '-' : ''
    var i = String(
      parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
    )
    var j = (j = i.length) > 3 ? j % 3 : 0

    return (
      '$ ' +
      sign +
      (j ? i.substr(0, j) + thouSep : '') +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(number - i)
            .toFixed(decPlaces)
            .slice(2)
        : '')
    )
  },
}
